<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <PartItem v-for="item in partList" :key="item.id" :part="item" @onRefresh="onRefresh"/>
            </List>
        </PullRefresh>
        <Button type="info" block class="fixed-bottom-button" @click="addPart">新增配件</Button>
        <PartPopup :show="show" type="partPopup" @panel="switchPanel" @onRefresh="onRefresh"/>
    </div>
</template>

<script>
    import {Button, PullRefresh, List} from "vant"
    import PartItem from "../components/PartItem"
    import PartPopup from "../components/PartPopup"

    export default {
        components: {PartPopup, PartItem, PullRefresh, Button, List},
        props: {},
        data() {
            return {
                deviceId: this.$route.params.id,
                isReFresh: false,
                loading: false,
                finished: false,
                partList: [],
                show: false
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            addPart() {
                this.show = true;
            },
            switchPanel(type, data) {
                switch (type) {
                    case "partPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            onRefresh() {
                this.isReFresh = true;
                this.partList = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.part.list({
                    deviceId: this.deviceId,
                    size: 20,
                    page: this.partList.length / 20 + 1
                }).then(res => {
                    if (res) {
                        this.partList.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.partList.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch: {}
    }
</script>

<style scoped>
    .fixed-bottom-button {
        position: fixed;
        bottom: 55px;
        width: calc(100% - 16px);
    }
</style>